import { render, staticRenderFns } from "./WorkplacePhysicianCompanyList.vue?vue&type=template&id=2f77d206&scoped=true&"
import script from "./WorkplacePhysicianCompanyList.vue?vue&type=script&lang=js&"
export * from "./WorkplacePhysicianCompanyList.vue?vue&type=script&lang=js&"
import style0 from "./WorkplacePhysicianCompanyList.vue?vue&type=style&index=0&id=2f77d206&lang=scss&scoped=true&"
import style1 from "./WorkplacePhysicianCompanyList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f77d206",
  null
  
)

export default component.exports